module.exports = __webpack_public_path__ + "static/media/youTravelBackground.efa514e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/YouTravel/images/youTravelBackground.jpg
// module id = 404
// module chunks = 0